import {openPageAsync} from "../api/GeneralApi";
import React, {PropsWithChildren, useContext, useEffect} from "react";
import {PreviewDataContext} from "./PreviewContext";


export const GeneralContext = React.createContext({});

export const GeneralProvider: React.FunctionComponent<PropsWithChildren> = ({children}) => {
    const previewContext = useContext(PreviewDataContext);

    const openPageEvent = async () => {
        const response = await openPageAsync(previewContext.isPreviewMode);
        return null;
    }

    useEffect(() => {
        if (previewContext.isPreviewInited) {
            openPageEvent()
        }
    }, [previewContext.isPreviewInited]);

    return (
        <GeneralContext.Provider value={{}}>
            {children}
        </GeneralContext.Provider>
    )
}